import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { UserService, Utils, TaxkeyService } from 'frilans-finans';
import { CountryPicker, GeneralError, SpinnerButton, InputField } from 'components';
import { setSocialSecurityNr } from 'redux/modules/user/index';

export class PersonalInfo extends React.Component {

  static propTypes = {
    setSocialSecurityNr: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      showErrorWithoutBlur: false,
      posting: false,
      user: (props.user) ? this.getUserObject(props.user) : null,
      userUpdated: false,
      postError: false
    };

    this.callback = this.callback.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.setCountry = this.setCountry.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (!this.state.user) {
      this.setState({
        user: this.getUserObject(nextProps.user)
      });
    }
  }

  getUserObject (user) {
    let userObj = Utils.getInputValueObjects(user);

    return {
      firstName: userObj.firstName,
      lastName: userObj.lastName,
      email: userObj.email,
      street: userObj.street,
      zip: userObj.zip,
      city: userObj.city,
      co: userObj.co,
      country: userObj.country,
      cellphone: userObj.cellphone,
      socialSecurityNr: userObj.socialSecurityNr,
      receiveSmsNotifications: userObj.receiveSmsNotifications,
      receiveEmailNotifications: userObj.receiveEmailNotifications
    };
  }

  setCountry (country) {
    this.callback('country', {value: country, valid: true});
  }

  callback (name, values) {
    this.setState({user: this.getUserState(name, values)});
  }

  getUserState (name, values) {
    let tempFormValues = this.state.user;
    Object.assign(tempFormValues[name], values);
    return tempFormValues;
  }

  submitForm () {
    var params = Utils.getPostParams(this.state.user);
    UserService.update(params)
      .then(this.handleSuccess)
      .catch(this.handleError);

    this.setState({
      posting: true,
      userUpdated: false,
      postError: false
    });
  }

  handleSuccess (user) {
    TaxkeyService.get(user.id);

    this.setState({
      posting: false,
      userUpdated: true,
      postError: false
    });
  }

  handleError (error) {
    let userState = this.state.user;

    if (UserService.hasErrorFor('social_security_number', error)) {
      this.props.setSocialSecurityNr('');
      userState = this.getUserState('socialSecurityNr', { value: '', valid: false });
    }

    let errors = UserService.getError(error);

    this.setState({
      showErrorWithoutBlur: false,
      posting: false,
      userUpdated: false,
      postError: true,
      errorMessage: errors,
      user: userState
    });
  }

  clickSubmit (e) {
    e.preventDefault();

    this.setState({showErrorWithoutBlur: true}, () => {
      if (Utils.validateInputValues(this.state.user)) {
        this.submitForm();
        this.props.setSocialSecurityNr(this.state.user.socialSecurityNr.value);
      }
    });
  }

  renderPostSuccess () {
    return (
      <p className='info'><Translate content='SETTINGS_UPDATED' /></p>
    );
  }

  renderPostError () {
    if (this.state.postError) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className='error' key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  render () {
    if (this.state.user.firstName) {
      let userUpdated = this.state.userUpdated ? this.renderPostSuccess() : false;
      let disableSocialSecurityNr;
      if (this.props.user === undefined) {
        disableSocialSecurityNr = 'false';
      } else {
        disableSocialSecurityNr = this.props.user.socialSecurityNr
          ? 'true' : 'false';
      }

      return (
        <div className='personal-info'>
          <h2><Translate content='PERSONAL_INFO'/></h2>
          <p className='large-margin'><Translate content='SETTINGS_TEXT'/></p>
          <form>
            <div className='form-row'>
              <InputField type='text' name='firstName' value={this.state.user.firstName.value}
                placeholder={proxyCounterpart('FIRST_NAME')} callback={this.callback}
                required='true' minLength='2' errorMessage={proxyCounterpart('FIRST_NAME_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <InputField type='text' name='lastName' value={this.state.user.lastName.value}
                placeholder={proxyCounterpart('LAST_NAME')} callback={this.callback}
                required='true' minLength='2' errorMessage={proxyCounterpart('LAST_NAME_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
            </div>

            <div className='form-row'>
              <InputField type='email' name='email' value={this.state.user.email.value}
                placeholder={proxyCounterpart('EMAIL')} callback={this.callback}
                required='true' minLength='3' errorMessage={proxyCounterpart('EMAIL_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <InputField type='text' name='street' value={this.state.user.street.value}
                placeholder={proxyCounterpart('ADDRESS')} callback={this.callback}
                required='true' minLength='3' errorMessage={proxyCounterpart('ADDRESS_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
            </div>

            <div className='form-row'>
              <InputField type='text' name='zip' value={this.state.user.zip.value}
                placeholder={proxyCounterpart('POSTAL_CODE')} callback={this.callback}
                required='true' minLength='3' errorMessage={proxyCounterpart('POSTAL_CODE_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <InputField type='text' name='city' value={this.state.user.city.value}
                placeholder={proxyCounterpart('CITY')} callback={this.callback}
                required='true' minLength='2' maxLength="40" errorMessage={proxyCounterpart('CITY_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
            </div>
            <div className='form-row'>
              <InputField type='text' name='co' value={this.state.user.co.value}
                placeholder={proxyCounterpart('CO')} callback={this.callback}
                required='true' minLength='0' errorMessage={proxyCounterpart('CO_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <CountryPicker
                setCountry={this.setCountry}
                countryName={this.state.user.country.value}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur}
              />
            </div>
            <div className='form-row'>
              <InputField type='tel' name='cellphone' value={this.state.user.cellphone.value}
                placeholder={proxyCounterpart('TELEPHONE_NR')} callback={this.callback}
                required='true' minLength='8' errorMessage={proxyCounterpart('TELEPHONE_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <InputField type='text' validationType='personalNumber'
                name='socialSecurityNr' value={this.props.user === undefined ? '' : this.props.user.socialSecurityNr}
                placeholder={proxyCounterpart('PERSONAL_NUMBER')}
                disabled={disableSocialSecurityNr}
                callback={this.callback}
                required='true' minLength='3' errorMessage={proxyCounterpart('PERSONAL_NUMBER_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
            </div>

            {userUpdated}
            {this.renderPostError()}

            <div className='button-wrapper'>
              <SpinnerButton text={proxyCounterpart('SAVE_SETTINGS')}
                loading={this.state.posting} classes='btn' type='button' callback={this.clickSubmit}/>
            </div>

          </form>
        </div>
      );
    } else {
      return (
        <div></div>
      );
    }
  }
}

const mapStateToProps = function (state) {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSocialSecurityNr: (socialSecurityNr) => dispatch(setSocialSecurityNr(socialSecurityNr))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);



/** WEBPACK FOOTER **
 ** ./src/views/settings/personal-info/personal-info.js
 **/